// extracted by mini-css-extract-plugin
module.exports = {"container":"Pending_container_2wvEo","nameserver":"Pending_nameserver_3Ez-U","domains":"Pending_domains_fGp_o","textarea":"Pending_textarea_1pJff"};